/**
 * @deprecated Built-in action migrated to Actions API. Keeping around for
 * backwards compatibility.
 */
export const MARKETABLE = 'MARKETABLE';
/**
 * @deprecated Built-in action migrated to Actions API. Keeping around for
 * backwards compatibility.
 */
export const MARKETABLE_UNTIL_RENEWAL = 'MARKETABLE_UNTIL_RENEWAL';